
import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../utility/apiInstance";
import { Mail } from "lucide-react";
import toast from "react-hot-toast";
import "./paginationstyle.css";
import "./dashboard-table.css";
import "./dashboard-v3.css";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";

import Loading from "./Loading";
import { useRole } from "../MangeContextProvide";
import { useSocket } from "../../context/SocketContext";
import { getDefaultType } from "../../utility/getDefaultSevice";
import AddTrackingDrawerOpen from "./AddTrackingDrawerOpen";
import TrackingDrawer from "./ActionManagement/TrackingDrawer";
import { DashBoardItem, getTrackingStatusClass, groupShipments } from "./utilty";
import ShipmentRow from "./ShipmentRow";
import { useDashboard } from "./DashboardContext/DashboardContext";
import SelectBox from "../../common/SelectBox";

let debounceTimer = null as any;
const MIN_TABLE_HEIGHT = 360;
interface NewTable {
  preTransit?: number;
  inTransit?: { direct?: number; transShipment?: number };
  delivered?: number;
  delayed?: number;
  isPart?: number;
  archived?: { completed?: number; trackingEnded?: number };
}

const STAT_CONFIG = [
  { key: "preTransit", label: "Pre-Transit", color: "#8E8E93", sub: (t: NewTable) => "Awaiting dispatch", val: (t: NewTable) => t.preTransit ?? 0 },
  { key: "inTransit", label: "In-Transit", color: "#F8B71F", sub: (t: NewTable) => `Direct ${t.inTransit?.direct ?? 0} · Trans ${t.inTransit?.transShipment ?? 0}`, val: (t: NewTable) => (t.inTransit?.direct ?? 0) + (t.inTransit?.transShipment ?? 0) },
  { key: "delivered", label: "Delivered", color: "#22C55E", sub: (t: NewTable) => "This period", val: (t: NewTable) => t.delivered ?? 0 },
  { key: "isPart", label: "Part Shipment", color: "#A855F7", sub: (t: NewTable) => "Partial delivery", val: (t: NewTable) => t.isPart ?? 0 },
  { key: "delayed", label: "Delayed", color: "#EF4444", sub: (t: NewTable) => "Needs attention", val: (t: NewTable) => t.delayed ?? 0 },
  // { key: "archived",    label: "Archived",       color: "#3B82F6", sub: (t: NewTable) => "Completed + ended",                                                     val: (t: NewTable) => (t.archived?.completed ?? 0) + (t.archived?.trackingEnded ?? 0) },
];

const PHASE_MAP: Record<string, string> = {
  preTransit: "Pre-Transit",
  inTransit: "In-Transit",
  delivered: "Delivered",
  isPart: "isPart",
  delayed: "Delayed",
  archived: "archived",
};


// ── component ──────────────────────────────────────────────
function Dashboardtable({ initialFilteredData }: { initialFilteredData: DashBoardItem[] }) {
  const { unreadReadCount } = useRole() as any;
  const [open, setOpen] = useState(false);
  const [filteredData, setFilteredData] = useState<DashBoardItem[]>(initialFilteredData);
  const [loading, setLoading] = useState(false);

  const [paginationModel, setPaginationModel] = useState({
    page: 0, pageSize: 10, limit: 0, totalCount: 0, unread: "unread", read: "read",
  });

  const [selectedTrackingId, setSelectedTrackingId] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const [newTable, setNewTable] = useState<NewTable>({});
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState<Record<number, boolean>>({});
  const [readUreadData, setReadUnReadData] = useState<{ mawbs: string[]; oceans: string[] }>({ mawbs: [], oceans: [] });
  const [searchText, setSearchText] = useState<string>("");
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const [activePhase, setActivePhase] = useState<string | null>(null);
  const [activeStatKey, setActiveStatKey] = useState<string | null>("");
  // const [selectedItem, setSelectedItem] = useState<DashBoardItem | null>(null);
  const [openActionDrawer, setOpenActionDrawer] = useState(false);
  const { selectedItem, setSelectedItem } = useDashboard() as any;

  const socket = useSocket();
  const { module, grouppedByPrefrence, role, masterCustomFields, setGrouppedByPrefrence }: any = useRole();
  const modules = module || [];

  const [accessModule, setAccessModule] = useState(getDefaultType(modules, role));
  const [queryOptions, setQueryOptions] = useState({ accessModule: getDefaultType(modules, role), memberId: [] as string[] });
  const [chooseTeam, setChooseTeam] = useState({ teamId: "" });
  const [membersList, setMemberList] = useState<any>([]);
  const [teamList, setTeamList] = useState<any>([]);
  const [teamMemberList, setTeamMemberList] = useState<any>([]);
  const [selectedMember, setSelectedMember] = useState({ memberId: "" });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showAirBulk, setShowAirBulk] = useState(false);
  const [showOceanBulk, setShowOceanBulk] = useState(false);

  const [groupBy, setGroupBy] = useState<string>(grouppedByPrefrence.grouppedByPrefrence);
  const [selectedCustomField, setSelectedCustomField] = useState<string>(grouppedByPrefrence.customFieldByPrefrence);
  const [collapsedGroups, setCollapsedGroups] = useState<Record<string, boolean>>({})
  const [customerFilter, setCustomerFilter] = useState<string>("");

  const open1 = Boolean(anchorEl1);


  // ── data fetching ──
  const fetchData = async (page: number, pageSize: number, options: any, selFilter: string, read: string, unread: string) => {
    let qs = `read=${selFilter}`;
    if (options?.phase) qs += `&phase=${options.phase}`;
    if (options?.search) qs += `&search=${options.search}`;
    if (options?.accessModule) qs += `&accessModule=${options.accessModule}`;
    if (options?.memberId) qs += `&memberId=${options.memberId}`;
    if (options?.customer) qs += `&customer=${options.customer}`;
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/api/v1/airwaybill/awb/recent-update?page=${page}&pageSize=${pageSize}&${qs}`);
      const data = response?.data?.data || [];
      const formatted = data?.data?.map((item: any, index: number) => ({
        ...item,
        id: item.id,
        index: page * pageSize + index + 1,
      }));
      setPaginationModel(prev => ({ ...prev, totalCount: data?.count, limit: data?.pageSize }));
      setFilteredData(formatted);
    } catch {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handleNewTable = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/dashboard/shipment-status");
      setNewTable(response?.data?.data);
    } catch { }
  };

  const fetchTeamLeadersList = async () => {
    try {
      const { data } = await axiosInstance.get("/api/v1/customer-team/checkisleader");
      setTeamList(data?.data?.leaderTeams || []);
      setTeamMemberList(data?.data?.memberTeams || []);
    } catch {

    }
  };

  useEffect(() => { handleNewTable(); fetchTeamLeadersList(); }, []);


  useEffect(() => {
    const pageSize = groupBy ? paginationModel.totalCount || 1000 : paginationModel.pageSize;
    const page = groupBy ? 0 : paginationModel.page;
    fetchData(page, pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
  }, [queryOptions, paginationModel.page, paginationModel.pageSize, selectedFilter, selectedTrackingId]);


  useEffect(() => {
    if (groupBy && filteredData.length < paginationModel.totalCount) {

      fetchData(0, paginationModel.totalCount || 1000, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);

    } else {
      fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    }
  }, [groupBy]);

  // ── team member resolution ──
  useEffect(() => {
    const selected = teamList?.find((t: any) => t?._id === chooseTeam?.teamId);
    const data = selected?.teamMembers;
    if (Array.isArray(data) && data.length > 0) {
      const ids = data.map((m: any) => m._id);
      setQueryOptions(prev => ({ ...prev, memberId: ids }));
      setMemberList(data.map((m: any) => ({ name: m?.name, _id: m?._id })));
    }
  }, [chooseTeam]);

  // ── socket ──
  useEffect(() => {
    if (!socket) return;
    socket.on("dashboard-data", (response) => {
      const data = response?.data || [];
      const formatted = data.map((item: any, index: number) => ({
        ...item,
        id: paginationModel.page * paginationModel.pageSize + index + 1,
        index: paginationModel.page * paginationModel.pageSize + index + 1,
      }));

      const hasActiveFilter =
        selectedFilter !== "" ||
        searchText !== "" ||
        activePhase != null ||
        customerFilter !== "" || groupBy;

      if (paginationModel.page === 0 && !hasActiveFilter) {
        setPaginationModel(prev => ({ ...prev, totalCount: response?.count, limit: response?.pageSize }));
        setFilteredData(formatted);
      }
    });
    socket.on("shipementWise", (sw) => setNewTable(sw));
    return () => { socket.off("dashboard-data"); socket.off("shipementWise"); };
  }, [socket, paginationModel, activePhase]);


  const closeOfflineTrackingDrawer = () => {
    setOpenActionDrawer(false);
    fetchData(
      paginationModel.page,
      paginationModel.pageSize,
      queryOptions,
      selectedFilter,
      paginationModel.read,
      paginationModel.unread
    );
  };
  // ── handlers ──
  const handleStatClick = (key: string) => {
    const isActive = activeStatKey === key;
    const newKey = isActive ? null : key;
    setActiveStatKey(newKey);
    const phase = newKey ? PHASE_MAP[key] : "";
    setActivePhase(phase || null);
    setQueryOptions(prev => ({ ...prev, phase: phase }));
    setPaginationModel(prev => ({ ...prev, page: 0 }));
  };


  const handleRowClick = async (item: any) => {
    setOpenActionDrawer(true);
    if (!item?.mawb || !item["for"]) return;
    const payload = { mawbs: [] as string[], oceans: [] as string[] };
    if (item["for"] === "air") payload.mawbs.push(item.mawb);
    else if (item["for"] === "ocean") payload.oceans.push(item.mawb);
    else return;
    try {
      await axiosInstance.post("/api/v1/dashboard/changeToRead", payload);
      setReadUnReadData({ mawbs: [], oceans: [] });
      unreadReadCount();
      fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    } catch { }
  };

  const handleReadCheckbox = async () => {
    if (!readUreadData.mawbs.length && !readUreadData.oceans.length) { toast.error("Please select a record."); return; }
    try {
      await axiosInstance.post("/api/v1/dashboard/changeToRead", readUreadData);
      setReadUnReadData({ mawbs: [], oceans: [] }); setSelectAll(false); unreadReadCount();
      fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    } catch { }
  };

  const handleUnreadCheckbox = async () => {
    if (!readUreadData.mawbs.length && !readUreadData.oceans.length) { toast.error("Please select a record."); return; }
    try {
      await axiosInstance.post("/api/v1/dashboard/changeToUnRead", readUreadData);
      setReadUnReadData({ mawbs: [], oceans: [] });
      setSelectAll(false);
      unreadReadCount();
      fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    } catch { }
  };

  const handleSelectAll = (event: any) => {
    const checked = !selectAll;
    setSelectAll(checked);
    const updatedSelections = filteredData.reduce((acc: any, item: any) => { acc[item.id] = checked; return acc; }, {});
    setSelectedCheckboxes(updatedSelections);
    if (checked) {
      setReadUnReadData({
        oceans: filteredData.filter((i: any) => i.for === "ocean").map((i: any) => i.mawb),
        mawbs: filteredData.filter((i: any) => i.for === "air").map((i: any) => i.mawb),
      });
    } else {
      setReadUnReadData({ mawbs: [], oceans: [] });
    }
  };

  const handleCheckboxChange = (event: any, item: any) => {
    const checked = event.target.checked;
    if (item.for === "ocean") {
      setReadUnReadData(prev => ({ ...prev, oceans: checked ? [...prev.oceans, item.mawb] : prev.oceans.filter((id: any) => id !== item.mawb) }));
    } else if (item.for === "air") {
      setReadUnReadData(prev => ({ ...prev, mawbs: checked ? [...prev.mawbs, item.mawb] : prev.mawbs.filter((id: any) => id !== item.mawb) }));
    }
  };

  const onSearch = (value: string) => {
    setSearchText(value);
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      setQueryOptions(prev => ({ ...prev, search: value }));
    }, 700);
  };


  const handleRefresh = () => {
    // 1. Cancel any pending debounced search — prevents a stale setQueryOptions firing after reset
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }

    const defaultModule = getDefaultType(modules, role);

    // 2. Reset all UI state (none of these trigger fetchData directly)
    setSearchText("");
    setSelectedTrackingId("");
    setReadUnReadData({ mawbs: [], oceans: [] });
    setSelectAll(false);
    setSelectedCheckboxes({});
    setActivePhase(null);
    setActiveStatKey(null);
    setSelectedFilter("");
    setGroupBy("");
    setSelectedCustomField("");
    setChooseTeam({ teamId: "" });
    setSelectedMember({ memberId: "" });
    setMemberList([]);
    // setPaginationModel(prev => ({ ...prev, page: 0 }));

    // 3. Single setQueryOptions — triggers the useEffect exactly once → one API call
    setQueryOptions({ accessModule: defaultModule, memberId: [] });
    setCustomerFilter("");
  };
  const handleTeamChange = async (value: any) => {
    setChooseTeam(prev => ({ ...prev, teamId: value }));
    if (value === "") {
      setMemberList([]);
      setQueryOptions(prev => ({ ...prev, memberId: [] }));
      await fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    }
  };
  const handleMemberChange = async (value: any) => {
    setSelectedMember(prev => ({ ...prev, memberId: value }));
    setQueryOptions(prev => ({ ...prev, memberId: [value] }));

    if (value === "") {
      setMemberList([]);
      setQueryOptions(prev => ({ ...prev, memberId: [] }));
      await fetchData(paginationModel.page, paginationModel.pageSize, queryOptions, selectedFilter, paginationModel.read, paginationModel.unread);
    }
  };

  const toggleGroup = (groupKey: string) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  const updateGroupPreference = async (groupBy: string, customFieldPreference: string) => {
    return await axiosInstance.post(
      "/api/v1/customers-auth/update-group-preference",
      {
        grouppedByPrefrence: groupBy,
        customFieldByPrefrence: customFieldPreference
      }
    );
  };


  const handleGroupChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ): Promise<void> => {
    const value = e.target.value;

    // update UI immediately
    setGroupBy(value);
    setSelectedCustomField("");

    try {
      await updateGroupPreference(value, "");
    } catch (error) {
      console.error(error);
    }
  };

  const handleCustomFieldChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ): Promise<void> => {
    const value = e.target.value;

    if (value === selectedCustomField) return;

    const prev = selectedCustomField;
    setSelectedCustomField(value);

    try {
      await updateGroupPreference(groupBy, value);
    } catch (error) {

      console.error(error);
    }
  };
  const grouped = groupShipments(filteredData, groupBy, selectedCustomField);

  const isChecked = (item: DashBoardItem) => readUreadData.mawbs.concat(readUreadData.oceans).includes(item.mawb);

  const handleCustomerFilterChange = (value: string) => {
    setCustomerFilter(value);
    setQueryOptions(prev => ({ ...prev, customer: value }));
    setPaginationModel(prev => ({ ...prev, page: 0 }));
  };
  // ── render ──
  return (
    <div className="v3-shell">

      {/* ── CONTENT ── */}
      <div className="v3-main">
        <div className="v3-content">

          {/* ── STAT CARDS (hidden for groundstaff) ── */}
          {role !== "groundstaff" && (
            <div className="v3-stats">
              {STAT_CONFIG.map(cfg => (
                <div
                  key={cfg.key}
                  className={`v3-stat-card${activeStatKey === cfg.key ? " v3-active" : ""}`}
                  style={{ "--v3-cc": cfg.color } as React.CSSProperties}
                  onClick={() => !loading && handleStatClick(cfg.key)}
                >
                  <div className="v3-stat-label">{cfg.label}</div>
                  <div className="v3-stat-val">{cfg.val(newTable)}</div>
                  <div className="v3-stat-sub">{cfg.sub(newTable)}</div>
                  <div className="v3-stat-close">
                    <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ── TABLE CARD ── */}
          <div className="v3-tcard">

            {/* combined toolbar */}
            <div className="v3-ctb">

              {/* LEFT: search + type + status */}
              <div className="v3-ctb-left">
                <div className="v3-sr">
                  <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
                  <input
                    type="text"
                    placeholder="Search AWB, container, route…"
                    value={searchText}
                    onChange={e => onSearch(e.target.value)}
                  />
                </div>

                {accessModule === "both" && (
                  <SelectBox
                    value={queryOptions?.accessModule}
                    onChange={(val) => {
                      setQueryOptions(prev => ({ ...prev, accessModule: val }));
                      if (teamList?.length > 0 || teamMemberList?.length > 0) {
                        setQueryOptions(prev => ({ ...prev, memberId: [] }));
                        setChooseTeam(prev => ({ ...prev, memberId: "" }));
                        setMemberList([]);
                      }
                    }}
                    options={[
                      { label: "Air / Ocean", value: "both" },
                      { label: "Air", value: "air" },
                      { label: "Ocean", value: "ocean" },
                    ]}
                  />
                )}



                {/* team */}
                {role !== "groundstaff" && (teamList?.length > 0) && (
                  <SelectBox
                    value={chooseTeam?.teamId || ""}
                    onChange={handleTeamChange}
                    style={{ height: 28, minHeight: 28, maxHeight: 28 }}
                  >
                    {teamList.map((t: any) => <option key={t._id} value={t._id}>{t.teamName}</option>)}
                    <option value="">Self Created</option>
                  </SelectBox>
                )}

                {/* team Member List*/}
                {role !== "groundstaff" && (membersList.length > 0) && (
                  <SelectBox
                    value={selectedMember?.memberId || ""}
                    onChange={handleMemberChange}
                    style={{ height: 28, minHeight: 28, maxHeight: 28 }}
                    options={membersList.map((t: any) => ({ label: t.name, value: t._id }))}
                  />
                )}
                {/* Grouped by*/}
                {role !== "groundstaff" && (
                  <SelectBox
                    value={groupBy}
                    onChange={(val) => handleGroupChange({ target: { value: val } } as any)}
                    options={[
                      { label: "Group By", value: "" },
                      { label: "Added date", value: "date" },
                      { label: "Carrier", value: "carrier" },
                      { label: "Route", value: "route" },
                      { label: "Custom field", value: "custom" },
                    ]}
                  />


                )}
                {role !== "groundstaff" && groupBy === "custom" && (
                  <SelectBox
                    value={selectedCustomField}
                    onChange={(val) => handleCustomFieldChange({ target: { value: val } } as any)}
                    placeholder="Select field…"
                    options={masterCustomFields.map((f: any) => ({ label: f.fieldName, value: f.fieldName }))}
                  />
                )}
                {/* Customer with / without filter */}
                {role !== "groundstaff" && (
                  <SelectBox
                    value={customerFilter}
                    onChange={handleCustomerFilterChange}
                    options={[
                      { label: "All", value: "" },
                      { label: "With customer", value: "withcustomer" },
                      { label: "Without customer", value: "withoutcustomer" },
                    ]}
                  />
                )}

              </div>

              <div className="v3-divider" />

              {/* RIGHT: checkbox, read filter, refresh, actions, pagination */}
              <div className="v3-ctb-right">
                {role !== "groundstaff" && (
                  <>
                    <input type="checkbox" className="v3-cb" id="v3-sa" checked={selectAll} onChange={handleSelectAll} />
                    <SelectBox
                      value={selectedFilter}
                      onChange={(val) => { setSelectedFilter(val); setPaginationModel(prev => ({ ...prev, page: 0 })); }}
                      options={[
                        { label: "All", value: "" },
                        { label: "Read", value: "read" },
                        { label: "Unread", value: "unread" },
                      ]}
                    />
                    <button className="v3-ib" title="Refresh" onClick={handleRefresh}>
                      <svg viewBox="0 0 24 24"><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" /></svg>
                    </button>
                    <button
                      className="v3-ib"
                      title="Mark as read/unread"
                      onClick={e => setAnchorEl1(e.currentTarget as HTMLElement)}
                    >
                      <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /><circle cx="5" cy="12" r="1" /></svg>
                    </button>
                    <Menu anchorEl={anchorEl1} open={open1} onClose={() => setAnchorEl1(null)} TransitionComponent={Fade}>
                      <MenuItem onClick={() => { setAnchorEl1(null); handleReadCheckbox(); }}>
                        <Mail style={{ width: 15, marginRight: 8 }} /> Mark as read
                      </MenuItem>
                      <MenuItem onClick={() => { setAnchorEl1(null); handleUnreadCheckbox(); }}>
                        <Mail style={{ width: 15, marginRight: 8 }} /> Mark as unread
                      </MenuItem>
                    </Menu>
                    <div className="v3-divider" />
                  </>
                )}



                {/* Only show pagination when not grouped */}
                {!groupBy && (() => {
                  const totalPages = Math.max(1, Math.ceil(paginationModel.totalCount / paginationModel.pageSize));
                  const canPrev = paginationModel.page > 0;
                  const canNext = paginationModel.page < totalPages - 1;
                  return (
                    <>
                      <span className="v3-pg-info">
                        {paginationModel.totalCount === 0 ? 0 : paginationModel.page * paginationModel.pageSize + 1}–
                        {Math.min((paginationModel.page + 1) * paginationModel.pageSize, paginationModel.totalCount)}
                        of {paginationModel.totalCount}
                      </span>
                      <button
                        type="button"
                        aria-label="Previous page"
                        className="v3-pgb"
                        disabled={!canPrev}
                        style={{ opacity: canPrev ? 1 : 0.4, cursor: canPrev ? "pointer" : "default" }}
                        onClick={() => canPrev && setPaginationModel(prev => ({ ...prev, page: prev.page - 1 }))}
                      >
                        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6" /></svg>
                      </button>
                      <button
                        type="button"
                        aria-label="Next page"
                        className="v3-pgb"
                        disabled={!canNext}
                        style={{ opacity: canNext ? 1 : 0.4, cursor: canNext ? "pointer" : "default" }}
                        onClick={() => canNext && setPaginationModel(prev => ({ ...prev, page: prev.page + 1 }))}
                      >
                        <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6" /></svg>
                      </button>
                    </>
                  );
                })()}

              </div>
            </div>

            {/* ── TABLE ── */}
            <div className="v3-tw" style={{ minHeight: MIN_TABLE_HEIGHT }}>
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "48px", minHeight: MIN_TABLE_HEIGHT }}>
                  <Loading />
                </div>
              ) : (
                <table className="v3-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Connection</th>
                      <th>AWB / Container</th>
                      <th>Route</th>
                      <th>Type</th>
                      <th>Status</th>

                      <th>Milestone Progress</th>
                      <th>Added</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>


                    {filteredData?.length === 0 && (
                      <tr>
                        <td colSpan={11} style={{ textAlign: "center", height: MIN_TABLE_HEIGHT, padding: "32px", color: "#8E8E93" }}>
                          No shipments found
                        </td>
                      </tr>
                    )}

                    {grouped
                      ? Object.entries(grouped).map(([groupKey, items]) => (
                        <React.Fragment key={groupKey}>
                          <tr className="v3-group-header" onClick={() => {
                            toggleGroup(groupKey);
                          }}>
                            <td colSpan={9}>
                              <span className="v3-group-dot" />
                              {groupKey}
                              <span className="v3-group-count">{items.length} {items.length === 1 ? "shipment" : "shipments"}</span>
                              <span className="v3-group-chevron">{collapsedGroups[groupKey] ? "▶" : "▼"}</span>
                            </td>
                          </tr>
                          {
                            !collapsedGroups[groupKey] && items.map((item: DashBoardItem) => (
                              <ShipmentRow
                                key={item.id}
                                item={item}
                                checked={isChecked(item)}
                                onRowClick={(i) => { handleRowClick(i); setSelectedItem(i); }}
                                onCheckboxChange={handleCheckboxChange}
                              />
                            ))
                          }
                        </React.Fragment>
                      ))
                      : filteredData.map((item: DashBoardItem) => (
                        <ShipmentRow
                          key={item.id}
                          item={item}
                          checked={isChecked(item)}
                          onRowClick={(i) => { handleRowClick(i); setSelectedItem(i); }}
                          onCheckboxChange={handleCheckboxChange}
                        />
                      ))
                    }



                  </tbody>
                </table>
              )}
            </div>
          </div>

        </div>{/* /v3-content */}
      </div>{/* /v3-main */}


      {/* ── FLOATING ADD BUTTON ── */}
      {role !== "groundstaff" && (
        <div className="v3-fab-wrap">
          <span className="v3-fab-label">Add Shipment</span>
          <button className="v3-fab" onClick={
            () => {
              setOpen(true)
              setDrawerOpen(true)
            }

          }>
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
          </button>
        </div>
      )}

      <AddTrackingDrawerOpen
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        setShowAirBulk={setShowAirBulk}
        setShowOceanBulk={setShowOceanBulk}
        showAirBulk={showAirBulk}
      />
      {openActionDrawer && (
        <TrackingDrawer open={openActionDrawer} onClose={closeOfflineTrackingDrawer} />
      )}

    </div>
  );
}

export default Dashboardtable;
